import { Text } from "@overmap-ai/blocks"
import { type Issue, type Stored, UNTITLED_ISSUE_TITLE } from "@overmap-ai/common"
import { selectUserById } from "@overmap-ai/core"
import { Link } from "@tanstack/react-router"
import { memo } from "react"

import { interactiveTextCva } from "../../cva"
import { ProjectTimelineItemType } from "../../enums/projects"
import { useAppSelector } from "../../store"
import { formatCompactDate } from "../../utils/date"
import { getUserDisplayLabel } from "../../utils/users"
import { IssueTypeIcon } from "../Icons/IssueTypeIcon"
import { IssueIndexLabel } from "../IndexLabels/IssueIndex"
import { ProjectTimelineCard } from "./ProjectTimelineCard"

interface ProjectTimelineIssueItemProps {
	issue: Stored<Issue>
}

export const ProjectTimelineIssueItem = memo<ProjectTimelineIssueItemProps>((props) => {
	const { issue } = props

	const user = useAppSelector(selectUserById(issue.created_by ?? -1))

	return (
		<ProjectTimelineCard type={ProjectTimelineItemType.ISSUE}>
			<Text size="sm" accentColor="base" className="min-w-0">
				<Text highContrast>{getUserDisplayLabel(user)}</Text>
				&nbsp;created issue&nbsp;
				<Link
					from="/$organizationId/$projectId"
					to="/$organizationId/$projectId/issues/$issueId"
					params={{ issueId: issue.uuid }}
				>
					<Text highContrast className={interactiveTextCva()}>
						<IssueTypeIcon className="align-sub" issueTypeId={issue.issue_type} />
						&nbsp;
						<IssueIndexLabel issueId={issue.uuid} highContrast />
						<Text accentColor="base">&nbsp;{issue.title || UNTITLED_ISSUE_TITLE}</Text>
					</Text>
				</Link>
				<Text accentColor="base">&nbsp;&#8226;&nbsp;{formatCompactDate(issue.submitted_at)}</Text>
			</Text>
		</ProjectTimelineCard>
	)
})
ProjectTimelineIssueItem.displayName = "ProjectTimelineIssueItem"
